export const novels = [
  {
    id: "2001",
    title: "剑起长歌",
    author: "风雪眠",
    cover: "https://readdy.ai/api/search-image?query=elegant%20chinese%20web%20novel%20book%20cover%20with%20a%20lone%20swordsman%20on%20a%20cliff%20under%20a%20huge%20moon%2C%20ink%20brush%20mountains%2C%20teal%20night%20tones%20with%20warm%20orange%20accent%2C%20wuxia%20atmosphere%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2001&orientation=portrait",
    genre: "玄幻",
    status: "连载中",
    wordCount: 1280000,
    summary: "一柄锈剑，一介凡人，从此踏上问鼎巅峰的长歌之路。",
    intro: "少年林长歌出身剑道凋零的偏远小城，因一场意外得到一柄沉睡的锈剑。剑中残存着上古剑仙的一缕意志，也背负着一段被埋葬的恩怨。为了查明父母失踪的真相，他走出故乡，在宗门林立、强者如云的世界里，一步一步用手中的剑，劈开属于自己的道路。这是一个关于坚持与成长的故事，也是一曲荡气回肠的剑道长歌。",
    chapters: [
      "第一章 锈剑出鞘",
      "第二章 小城风雨",
      "第三章 拜入青云",
      "第四章 擂台上的一剑",
      "第五章 剑仙残念",
      "第六章 初入江湖",
      "第七章 黑风寨之变",
      "第八章 长歌当哭",
    ],
    tags: ["热血", "升级流", "剑道"],
    recommend: 9820,
  },
  {
    id: "2002",
    title: "城南旧事录",
    author: "陆知味",
    cover: "https://readdy.ai/api/search-image?query=nostalgic%20chinese%20novel%20cover%20of%20an%20old%20southern%20city%20alley%20at%20dusk%2C%20traditional%20tile%20roofs%20and%20lanterns%2C%20teal%20blue%20evening%20tones%20with%20warm%20orange%20lamp%20glow%2C%20literary%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2002&orientation=portrait",
    genre: "都市",
    status: "已完结",
    wordCount: 860000,
    summary: "一条老街，几户人家，写尽人间烟火的悲欢离合。",
    intro: "城南的一条老巷即将拆迁，老裁缝陆叔在整理旧物时，翻出了一摞泛黄的信件。信中记录着几十年间巷子里的人事变迁——有青梅竹马的错过，有邻里间的守望相助，也有一代人在时代浪潮中的沉浮。小说以细腻温润的笔触，描绘出一幅市井生活的长卷，让每一个读者都能在其中找到自己熟悉的影子。",
    chapters: [
      "第一章 老巷要拆了",
      "第二章 一摞旧信",
      "第三章 巷口的豆浆摊",
      "第四章 青梅与竹马",
      "第五章 那年夏天",
      "第六章 归人未归",
      "第七章 最后一盏灯",
      "第八章 城南再无旧事",
    ],
    tags: ["温情", "群像", "现实主义"],
    recommend: 8760,
  },
  {
    id: "2003",
    title: "星轨边缘",
    author: "夜航船",
    cover: "https://readdy.ai/api/search-image?query=sci-fi%20chinese%20novel%20cover%20of%20a%20vast%20space%20station%20orbiting%20a%20ringed%20planet%2C%20stars%20and%20nebula%2C%20teal%20cosmic%20tones%20with%20orange%20engine%20glow%2C%20futuristic%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2003&orientation=portrait",
    genre: "科幻",
    status: "连载中",
    wordCount: 520000,
    summary: "当人类文明被囚禁在星轨之内，一个观测员决定走向边界。",
    intro: "在遥远的未来，人类文明被限制在一道名为「星轨」的环形空间站带中，世代繁衍生息，无人知道轨道的尽头是什么。年轻的观测员苏黎在一次例行工作中，捕捉到一段来自轨道外的微弱信号。为了查明真相，她违抗禁令，沿着星轨一路前行，逐渐发现了一个足以颠覆整个文明认知的秘密。",
    chapters: [
      "第一章 观测员的一天",
      "第二章 轨外的信号",
      "第三章 禁令之下",
      "第四章 第七号舱段",
      "第五章 失踪的探险队",
      "第六章 边界之外",
      "第七章 文明的背面",
      "第八章 星轨尽头",
    ],
    tags: ["硬科幻", "悬疑", "探索"],
    recommend: 8210,
  },
  {
    id: "2004",
    title: "山河故人书",
    author: "顾长风",
    cover: "https://readdy.ai/api/search-image?query=historical%20chinese%20novel%20cover%20of%20ancient%20palace%20walls%20and%20mountain%20ranges%20under%20clouds%2C%20calligraphy%20scroll%20motif%2C%20teal%20ink%20wash%20with%20golden%20orange%20accents%2C%20epic%20literary%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2004&orientation=portrait",
    genre: "历史",
    status: "已完结",
    wordCount: 1560000,
    summary: "乱世之中，一位书生用一支笔，记下了整个山河的兴亡。",
    intro: "王朝倾覆之际，史官顾长风被卷入宫廷的权力漩涡。他手中握着记录天下大事的史笔，却要在忠义与生死之间反复抉择。从朝堂到边关，从繁华到废墟，他见证了英雄的陨落、百姓的流离，也见证了人性在最黑暗时刻依然闪烁的光。这是一部以史为骨、以人为本的宏大叙事作品。",
    chapters: [
      "第一章 史笔",
      "第二章 宫变之夜",
      "第三章 一纸诏书",
      "第四章 边关烽火",
      "第五章 故人相认",
      "第六章 山河破碎",
      "第七章 书成之日",
      "第八章 后人评说",
    ],
    tags: ["正剧", "权谋", "大历史"],
    recommend: 7930,
  },
  {
    id: "2005",
    title: "灯火阑珊处",
    author: "沈南枝",
    cover: "https://readdy.ai/api/search-image?query=romantic%20chinese%20novel%20cover%20of%20a%20rainy%20city%20street%20at%20night%20with%20glowing%20lanterns%20and%20umbrellas%2C%20teal%20blue%20rain%20tones%20with%20warm%20orange%20light%2C%20soft%20romantic%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2005&orientation=portrait",
    genre: "言情",
    status: "已完结",
    wordCount: 680000,
    summary: "兜兜转转多年后才发现，那人一直在灯火阑珊的尽头等她。",
    intro: "建筑师苏晚与摄影师江迟在大学毕业时因一场误会分道扬镳。五年后，两人因一个古城改造项目再度重逢。熟悉的城市、熟悉的街道，却已是物是人非。在共同完成项目的过程中，曾经的误会一点点被揭开，深藏心底的感情也重新被点亮。这是一个关于错过与重逢的都市爱情故事。",
    chapters: [
      "第一章 重逢在雨天",
      "第二章 旧城的计划",
      "第三章 那年的误会",
      "第四章 一起加班的夜",
      "第五章 未寄出的信",
      "第六章 阑珊灯火",
      "第七章 迟来的告白",
      "第八章 我们还有以后",
    ],
    tags: ["都市", "甜宠", "重逢"],
    recommend: 7480,
  },
  {
    id: "2006",
    title: "悬疑笔记",
    author: "墨无痕",
    cover: "https://readdy.ai/api/search-image?query=mystery%20chinese%20novel%20cover%20of%20a%20dark%20study%20desk%20with%20old%20notebooks%2C%20magnifying%20glass%20and%20candlelight%2C%20teal%20shadows%20with%20amber%20glow%2C%20suspenseful%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2006&orientation=portrait",
    genre: "悬疑",
    status: "连载中",
    wordCount: 430000,
    summary: "一本会自己增加内容的笔记，记录着一桩桩尚未发生的案件。",
    intro: "推理小说家墨白偶然得到一本空白笔记，诡异的是，每当他写下人物与场景，现实中便会真实地发生相似的案件。为了阻止悲剧，他开始利用笔记中的线索提前介入调查，却发现自己越陷越深，笔记的最后一页似乎早已写好了关于他自己的结局。这是一个环环相扣、层层反转的悬疑故事。",
    chapters: [
      "第一章 空白的笔记",
      "第二章 第一起案件",
      "第三章 笔迹的真相",
      "第四章 未写完的结局",
      "第五章 谁是作者",
      "第六章 双重陷阱",
      "第七章 第十三个名字",
      "第八章 落笔之前",
    ],
    tags: ["推理", "反转", "烧脑"],
    recommend: 8640,
  },
  {
    id: "2007",
    title: "灵山问道",
    author: "云中鹤",
    cover: "https://readdy.ai/api/search-image?query=xianxia%20chinese%20novel%20cover%20of%20a%20mystic%20mountain%20with%20immortal%20pavilions%20in%20clouds%2C%20cranes%20flying%2C%20teal%20misty%20tones%20with%20golden%20orange%20dawn%20light%2C%20ethereal%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2007&orientation=portrait",
    genre: "仙侠",
    status: "已完结",
    wordCount: 2100000,
    summary: "凡人求道三千年，只为在灵山之巅问一句：何为长生？",
    intro: "出身寒微的药童云澈，因一次机缘踏上修仙之路。从炼气到化神，从人间到仙界，他见过长生者的孤独，也见过短命花开的绚烂。历经三千年劫难，当他终于站上灵山之巅，却发现所谓的长生，不过是另一场修行的开始。这是一部格局宏大、意境悠远的仙侠长卷。",
    chapters: [
      "第一章 药童云澈",
      "第二章 拜入灵山",
      "第三章 御剑之术",
      "第四章 劫云之下",
      "第五章 三千年约",
      "第六章 仙凡有别",
      "第七章 问道灵山",
      "第八章 长生如梦",
    ],
    tags: ["仙侠", "修行", "意境流"],
    recommend: 8910,
  },
  {
    id: "2008",
    title: "少年游侠传",
    author: "楚江秋",
    cover: "https://readdy.ai/api/search-image?query=wuxia%20chinese%20novel%20cover%20of%20a%20young%20wanderer%20in%20green%20robes%20walking%20a%20bamboo%20forest%20path%2C%20sword%20on%20back%2C%20teal%20green%20tones%20with%20warm%20orange%20sunlight%20through%20bamboo%2C%20heroic%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2008&orientation=portrait",
    genre: "武侠",
    status: "连载中",
    wordCount: 760000,
    summary: "少年仗剑走天涯，江湖恩怨，快意恩仇。",
    intro: "少年楚游身负血海深仇，独自踏入江湖。他不懂人情世故，只凭一腔热血与手中长剑，闯荡于各大门派之间。从被人算计到独当一面，他在一次次生死考验中成长，也逐渐看清了江湖背后的阴谋。恩怨情仇、快意恩仇，这是属于少年人的江湖。",
    chapters: [
      "第一章 少年下山",
      "第二章 客栈风波",
      "第三章 一招之约",
      "第四章 竹林遇险",
      "第五章 故人之子",
      "第六章 剑冢传说",
      "第七章 江湖再会",
      "第八章 快意恩仇",
    ],
    tags: ["武侠", "热血", "江湖"],
    recommend: 7640,
  },
  {
    id: "2009",
    title: "时光信箱",
    author: "温以宁",
    cover: "https://readdy.ai/api/search-image?query=warm%20youth%20chinese%20novel%20cover%20of%20a%20mailbox%20by%20a%20sunny%20window%20with%20letters%20and%20plants%2C%20soft%20teal%20tones%20with%20orange%20sunbeam%2C%20cozy%20nostalgic%20mood%2C%20vertical%20composition&width=600&height=900&seq=novel-cover-2009&orientation=portrait",
    genre: "青春",
    status: "已完结",
    wordCount: 380000,
    summary: "一封寄往十年前的挂号信，寄出了两代人的青春与遗憾。",
    intro: "高三那年，夏知遇在旧书店发现了一个标着「时光信箱」的铁盒，里面存着许多人写给过去或未来的信。出于好奇，她写下了一封。没想到，这封信真的被十年前的人收到，并改变了一个人的人生。当跨越时空的对话开始，夏知遇也逐渐明白了成长与放下的意义。",
    chapters: [
      "第一章 旧书店的铁盒",
      "第二章 写给十年前",
      "第三章 回信到了",
      "第四章 那个夏天",
      "第五章 错过的约定",
      "第六章 时间的答案",
      "第七章 最后一封信",
      "第八章 时光不负",
    ],
    tags: ["校园", "治愈", "成长"],
    recommend: 7020,
  },
];